import { useOrgData } from '@frontend/get-org-data';
import { useTranslation } from '@frontend/i18n';
import { useIsSingleTypeScope } from '@frontend/scope';
import { theme } from '@frontend/theme';
import { Chip, TextLink } from '@frontend/design-system';

export type LocationChipProps = {
  actionLabel?: string;
  chipLabel?: string;
  filteredLocationIds: string[];
  hideLocationChip?: boolean;
  isSingleLocation?: boolean;
  onActionClick?: React.MouseEventHandler<HTMLElement> & React.MouseEventHandler<HTMLAnchorElement>;
};

export function LocationChips({
  actionLabel,
  chipLabel,
  filteredLocationIds,
  hideLocationChip,
  isSingleLocation,
  onActionClick,
}: LocationChipProps) {
  const { t } = useTranslation('base');
  const isSingleTypeScope = useIsSingleTypeScope();
  const { getLocationName } = useOrgData();

  if (isSingleTypeScope || hideLocationChip) return null;
  const singleLocationId = filteredLocationIds[0];
  return (
    <div
      css={{
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
      }}
    >
      {(isSingleLocation && singleLocationId) || (filteredLocationIds?.length === 1 && filteredLocationIds[0]) ? (
        <Chip.SingleChip className='single-location-chip'>
          {chipLabel || getLocationName(isSingleLocation ? singleLocationId : filteredLocationIds[0])}
        </Chip.SingleChip>
      ) : (
        <Chip.MultiChip className='multi-location-chip'>
          {chipLabel || t(`{{count}} Locations`, { count: filteredLocationIds.length })}
        </Chip.MultiChip>
      )}
      {onActionClick ? (
        <TextLink
          weight='bold'
          css={{
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: theme.spacing(1),
            ':hover, :focus': {
              textDecoration: 'none',
            },
          }}
          onClick={(e) => {
            onActionClick?.(e);
          }}
        >
          {actionLabel ?? t('Edit')}
        </TextLink>
      ) : null}
    </div>
  );
}
